'use client';
// App
import { DialogCloseButtonProps } from './dialog-close-button.interfaces';
import Icon from '../icon';
import IconButton from '../icon-button';
import { Container } from './dialog-close-button.styles';

const DialogCloseButton = (props: DialogCloseButtonProps): JSX.Element => {
  const { className, onClick, iconButtonProps } = props;

  return (
    <Container className={className}>
      <IconButton onClick={onClick} aria-label="close" size="large" {...iconButtonProps}>
        <Icon name="close" size="small" />
      </IconButton>
    </Container>
  );
};

export default DialogCloseButton;
